<div class="modal-body">
  <div class="d-flex align-items-center justify-content-center mb-3">
    <h4 class="fw-bold fs-18 mb-0">{{'policy_updates' | translate}}</h4>
  </div>
  <div class="action--form">
    <div class="form-details">
      <ng-container *ngFor="let policy of policies">
        <h2 class="header-title fw-bold fs-18 mb-1">{{'update_our_policy' | translate}} {{policy.policyName}}</h2>
        <p class="fw-medium subtitle mb-4 fs-14">
          {{'click_here_to_read_the_new' | translate}}
          <span class="cursor-pointer" *ngIf="policy.terms === 'sellerTerms' || policy.terms === 'buyerTerms'"
                (click)="showPrivacyTerms('terms', policy.terms)">{{policy.policyName}}</span>
          <span class="cursor-pointer" *ngIf="policy.terms === 'sellerPolicy' || policy.terms === 'buyerPolicy'"
                (click)="showPrivacyTerms('privacy', policy.terms)">{{policy.policyName}}</span>
          <span class="cursor-pointer" *ngIf="policy.terms === 'cookiePolicy'"
                (click)="showCookies()">{{policy.policyName}}</span>
          <span class="cursor-pointer" *ngIf="policy.terms === 'paymentPolicy'"
                (click)="showPayment()">{{policy.policyName}}</span>
          <span class="cursor-pointer" *ngIf="policy.terms === 'returnPolicy'"
                (click)="showCookies('returnPolicy', 'return_policy')">{{policy.policyName}}</span>
          <span class="cursor-pointer" *ngIf="policy.terms === 'shippingPolicy'"
                (click)="showCookies('shippingPolicy', 'shopping_info')">{{policy.policyName}}</span>
        </p>
      </ng-container>
      <button class="btn-action w-auto px-4 mx-auto" (click)="confirmAll()">{{'accept_all' | translate}}</button>
    </div>
  </div>
</div>
